var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { applyCyAttribute } from "../../utils";
var Hamburger = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#000' : _b, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "36", height: "36", viewBox: "0 0 36 36" }, applyCyAttribute('hamburgerIcon'), props),
        React.createElement("path", { d: "M0 0h36v36h-36z", fill: "none" }),
        React.createElement("path", { d: "M4 27h28v-3h-28v3zm0-8h28v-3h-28v3zm0-11v3h28v-3h-28z" })));
};
export default Hamburger;
//# sourceMappingURL=Hamburger.js.map